
export default {
    name: 'ProductHuntSkip',

    methods: {
        hideModal() {
            this.$analytics.trackEvent('productHuntAbortSkipReview');
            this.$store.commit('ui/hideModal');
        },

        skipReview() {
            this.$analytics.trackEvent('productHuntSkipReview');
            this.$store.commit('ui/hideModal');
        },
    },
};
